"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/IRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_114)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_114`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H29.9298V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 15.993H30V23.993H-6V15.993ZM13.5649 9.45964C13.5719 9.59999 14.1754 11.2982 13.8737 12.2246C13.4105 13.6491 12.7649 13.7544 12.4842 13.9439V9.4035L12 9.10876L11.5158 9.4035V13.9439C11.2351 13.7544 10.6456 13.7754 10.1263 12.2246C9.82456 11.3333 10.5263 9.60701 10.5333 9.47368C10.5333 9.47368 9.86667 10.0421 9.42456 11.1579C9.01053 12.1965 9.55789 14.6386 11.4947 15.0035C11.6561 15.0316 11.8246 15.3965 12 15.3965C12.1474 15.3965 12.2877 15.0316 12.4211 15.0105C14.414 14.6877 14.8772 12.0842 14.5193 11.1088C14.1404 10.0842 13.5649 9.45964 13.5649 9.45964Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("g", {
					opacity: .5,
					children: /* @__PURE__ */ n("path", {
						d: "M-2.87018 6.94031H-1.30526V8.65259H-2.87018V6.94031ZM-6 6.94031H-4.43509V8.65259H-6V6.94031ZM0.259649 6.94031H1.82456V8.65259H0.259649V6.94031ZM3.38947 6.94031H4.95439V8.65259H3.38947V6.94031ZM6.5193 6.94031H8.08421V8.65259H6.5193V6.94031ZM9.64912 6.94031H11.214V8.65259H9.64912V6.94031ZM12.786 6.94031H14.3509V8.65259H12.786V6.94031ZM15.9158 6.94031H17.4807V8.65259H15.9158V6.94031ZM19.0456 6.94031H20.6105V8.65259H19.0456V6.94031ZM22.1754 6.94031H23.7404V8.65259H22.1754V6.94031ZM25.3053 6.94031H26.8702V8.65259H25.3053V6.94031ZM28.4351 6.94031H30V8.65259H28.4351V6.94031ZM-2.87018 15.221H-1.30526V17.0105H-2.87018V15.221ZM-6 15.221H-4.43509V17.0105H-6V15.221ZM0.259649 15.221H1.82456V17.0105H0.259649V15.221ZM3.38947 15.221H4.95439V17.0105H3.38947V15.221ZM6.5193 15.221H8.08421V17.0105H6.5193V15.221ZM9.64912 15.221H11.214V17.0105H9.64912V15.221ZM12.786 15.221H14.3509V17.0105H12.786V15.221ZM15.9158 15.221H17.4807V17.0105H15.9158V15.221ZM19.0456 15.221H20.6105V17.0105H19.0456V15.221ZM22.1754 15.221H23.7404V17.0105H22.1754V15.221ZM25.3053 15.221H26.8702V17.0105H25.3053V15.221ZM28.4351 15.221H30V17.0105H28.4351V15.221Z",
						fill: "white"
					})
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_114`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as IRFlag };
